// @flow

import PubSub from "./util/pubsub";
import { events } from "./site-overlay";

class NavPanel {
    static classes = {
        active: "is-active",
    };

    el: HTMLElement;
    id: string;
    togglers: NodeList<HTMLElement>;
    closeCTA: ?HTMLElement;
    currentOpener: ?HTMLElement;

    constructor(el: HTMLElement) {
        this.el = el;
        this.id = el.getAttribute("data-panel") || "";
        this.togglers = document.querySelectorAll(
            `[data-open-panel="${this.id}"]`
        );
        this.closeCTA = el.querySelector(".nav-panel__close__button");
        this.attachHandlers();
    }

    attachHandlers = () => {
        if (this.closeCTA) {
            this.closeCTA.addEventListener("click", this.close);
        }

        this.togglers.forEach((toggle: HTMLElement) => {
            toggle.addEventListener("click", this.toggle);
        });
    };

    toggle = (event: ?MouseEvent) => {
        if (this.el.classList.contains(NavPanel.classes.active)) {
            this.close();
        } else {
            this.open(event);
        }
    };

    open = (event: ?MouseEvent) => {
        PubSub.publish(events.show);
        this.el.classList.add(NavPanel.classes.active);
        this.el.setAttribute("aria-hidden", "false");
        this.el.setAttribute("aria-expanded", "true");

        if (event) {
            const target: HTMLElement = (event.currentTarget: any);
            target.classList.add(NavPanel.classes.active);
            target.setAttribute("aria-expanded", "true");
            this.currentOpener = target;
        }

        // Menu closable by clicking outside
        window.addEventListener("click", this.handleClickToClose);
        window.addEventListener("keyup", this.handleEscapeToClose);
    };

    close = () => {
        PubSub.publish(events.hide);
        this.el.classList.remove(NavPanel.classes.active);
        this.el.setAttribute("aria-hidden", "true");
        this.el.setAttribute("aria-expanded", "false");

        if (this.currentOpener) {
            const el = this.currentOpener;
            el.classList.remove(NavPanel.classes.active);
            el.setAttribute("aria-expanded", "false");
            this.currentOpener = null;
        }

        // Menu closable by clicking outside
        window.removeEventListener("click", this.handleClickToClose);
    };

    handleClickToClose = (event: MouseEvent) => {
        let shouldClose = true;

        if (this.el.contains((event.target: any))) {
            shouldClose = false;
        }

        this.togglers.forEach((el: HTMLElement) => {
            if (el.contains((event.target: any))) {
                shouldClose = false;
            }
        });

        if (shouldClose) {
            this.close();
        }
    };

    handleEscapeToClose = (event: KeyboardEvent) => {
        if (event.key === "Escape") {
            this.close();
        }
    };
}

const els = document.querySelectorAll("[data-panel]");
els.forEach((el: HTMLElement) => {
    new NavPanel(el);
});
